import { device } from '@/styles';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import styled from 'styled-components';

type Props = {
  disabled?: boolean;
  bold?: boolean;
  color?: string;
  background?: string;
  text: string;
  onClick: () => void;
  skipConnect?: boolean;
};

function BigWhiteButton({ text, onClick, disabled, color, background, skipConnect }: Props) {
  return (
    <ConnectButton.Custom>
      {(props) => {
        const { openConnectModal, account, mounted } = props;

        if (!mounted) {
          return <BigWhiteButtonContainer />;
        }

        if (account || skipConnect) {
          return (
            <BigWhiteButtonContainer
              background={background}
              color={color}
              disabled={disabled}
              onClick={onClick}
            >
              {text}
            </BigWhiteButtonContainer>
          );
        }

        return (
          <BigWhiteButtonContainer onClick={openConnectModal}>
            Connect Wallet
          </BigWhiteButtonContainer>
        );
      }}
    </ConnectButton.Custom>
  );
}

export const BigWhiteButtonContainer = styled.div<{
  disabled?: boolean;
  color?: string;
  background?: string;
}>`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.mobileM} {
    text-align: center;
  }

  background: ${(props) =>
    props.background ? props.background : props.disabled ? 'rgba(200,200,200,.6)' : '#ffffff'};
  color: ${(props) => (props.color ? props.color : props.disabled ? 'rgba(0,0,0,.5)' : '#000000')};
  border-radius: 36px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 500;

  ${(props) =>
    !props.disabled &&
    `
  &:hover {
    background: #e5e5e5;
    transform: scale(0.995);
    cursor: pointer;
  }
  `}

  transition: all 0.225s ease-in-out;
`;

export default BigWhiteButton;
